/* eslint-disable no-unused-vars,object-property-newline */
/* eslint-disable semi */
/* eslint-disable comma-dangle */
// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { Fragment } from 'react'
import { Slide, toast } from 'react-toastify'

import baseurl from '../../../@core/auth/jwt/baseurl'

const showErrorMsg = (error) => {
  toast.error(<Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <h6 className='toast-title fw-bold'>Error</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>{error}</span>
    </div>
  </Fragment>, {
    icon: false, transition: Slide, hideProgressBar: false, autoClose: 2000
  })
}

const showSuccessMsg = (msg) => {
  toast.success(<Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <h6 className='toast-title fw-bold'>Success</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>{msg}</span>
    </div>
  </Fragment>, {
    icon: false, transition: Slide, hideProgressBar: false, autoClose: 2000
  })
}

export const getData = createAsyncThunk('appManufacturingSite/getData', async (params) => {
  const response = await baseurl.get('/api/app/manufacturing-site', {
    params
  })
  return {
    params, data: response.data.items, total: response.data.totalCount
  }
}, {
  dispatchConditionRejection: true
})

export const getById = createAsyncThunk('appManufacturingSite/getById', async (id) => {
  try {
    const response = await baseurl.get(`/api/app/manufacturing-site/${id}`, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (response.status === 200) {
      return response.data
    } else if (res.status === 403) {
      showErrorMsg(res.data.error.message)
    }
    return rejectWithValue(response.data)
  } catch (error) {
    return rejectWithValue(error)
  }
}, {
  dispatchConditionRejection: true
})

export const getForMfsStanceById = createAsyncThunk('appManufacturingSite/getForMfsStanceById', async ({ caseId, mfsId }) => {
  try {
    const response = await baseurl.get(`/api/app/manufacturing-site-kurdistan-stance-case/manufacturing-site?caseId=${caseId}&manufacturingSiteId=${mfsId}`, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (response.status === 200) {
      return response.data
    } else if (res.status === 403) {
      showErrorMsg(res.data.error.message)
    }
    return rejectWithValue(response.data)
  } catch (error) {
    return rejectWithValue(error)
  }
}, {
  dispatchConditionRejection: true
})


export const getComments = createAsyncThunk('appManufacturingSite/getComments', async (id, { rejectWithValue }) => {
  try {
    const response = await baseurl.get(`/api/app/manufacturing-site/comments/${id}`, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (response.status === 200) {
      return {
        comments: typeof response.data === 'object' ? response.data : []
      }
    } else return rejectWithValue('')
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const addComment = createAsyncThunk('appManufacturingSite/addComment', async ({
                                                                                       comment,
                                                                                       callback
                                                                                     }, { rejectWithValue }) => {
  try {
    const response = await baseurl.post(`/api/app/manufacturing-site/comment`, comment, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }, headers: {
        'Content-Type': 'multipart/form-data', accept: 'text/plain'
      }
    })
    if (response.status === 200) {
      // dispatch(getLogs(getState().createCase?.mainCase?.id))
      callback()
      return response.data
    } else return rejectWithValue('')
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const deleteComment = createAsyncThunk('appManufacturingSite/deleteComment', async ({
                                                                                             id,
                                                                                             callback
                                                                                           }, { rejectWithValue }) => {
  try {
    const response = await baseurl.delete(`/api/app/manufacturing-site/comment/${id}`, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (response.status === 204) {
      // dispatch(getLogs(getState().createCase?.mainCase?.id))
      callback()
      return response.data
    } else return rejectWithValue('')
  } catch (error) {
    return rejectWithValue(error)
  }
})
export const addManufacturingSite = createAsyncThunk('appManufacturingSite/addManufacturingSite', async (manufacturingsite, {
  dispatch,
  getState,
  rejectWithValue
}) => {
  try {
    const res = await baseurl.post('/api/app/manufacturing-site', manufacturingsite, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (res.status === 200) {
      showSuccessMsg('Added Successfully')
      // emiter.emit('close-manufacturingsite-add-or-edit-popup')
      await dispatch(getData(getState().manufacturingSite.params))
      await dispatch(getById(res.data.id))
      return manufacturingsite
    } else if (res.status === 403) {
      showErrorMsg(res.data.error.message)
    }
    return null
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const updateManufacturingSite = createAsyncThunk('appManufacturingSite/updateManufacturingSite', async (manufacturingsite, {
  dispatch,
  getState,
  rejectWithValue
}) => {
  try {
    const res = await baseurl.put(`/api/app/manufacturing-site/${manufacturingsite.id}`, manufacturingsite, {
      validateStatus: (status) => {
        return status >= 200 && status <= 500
      }
    })
    if (res.status === 200) {
      showSuccessMsg('Updated Successfully')
      await dispatch(getData(getState().manufacturingSite.params))
      await dispatch(getById(manufacturingsite.id))
      return manufacturingsite
    } else if (res.status === 403) {
      showErrorMsg(res.data.error.message)
    }
    return null
  } catch (error) {
    return rejectWithValue(error)
  }
})

export const initManufacturingSite = createAsyncThunk('appManufacturingSite/initManufacturingSite', (loading) => loading, {})
export const loadManufacturingSiteLookups = createAsyncThunk('appManufacturingSite/loadManufacturingSiteLookups', async () => {
  const specialtiesResponse = await baseurl.get('/api/app/specialty', {
    params: {
      MaxResultCount: 1000
    }
  })

  const natureOfActivitiesResponse = await baseurl.get('/api/app/nature-of-activity', {
    params: {
      MaxResultCount: 1000
    }
  })
  const countriesResponse = await baseurl.get('/api/app/country', {
    params: {
      MaxResultCount: 1000
    }
  })

  const pdlActivitiesResponse = await baseurl.get('/api/app/production-line-activity', {
    params: {
      MaxResultCount: 1000
    }
  })

  return {
    specialties: specialtiesResponse.data?.items,
    countries: countriesResponse.data?.items,
    natureOfActivities: natureOfActivitiesResponse.data?.items,
    pdlActivities: pdlActivitiesResponse.data?.items
  }
}, {})

export const appManufacturingSiteSlice = createSlice({
  name: 'appManufacturingSite', initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedManufacturingSite: null,
    loading: true,
    getByIdLoading: false,
    saveLoading: false,
    commentsLoading: false,
    comments: []
  }, reducers: {
    deleteItem: (state, action) => {
      const newData = state.data?.filter((c) => c.id !== action.payload.id) ?? []
      state.data = newData
    }
  }, extraReducers: (builder) => {
    builder
      .addCase(getData.pending, (state) => {
        state.loading = true
      })
      .addCase(getData.rejected, (state) => {
        state.loading = false
      })
      .addCase(getData.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.total
        state.loading = false
      })

      .addCase(getById.pending, (state) => {
        state.getByIdLoading = true
        state.selectedManufacturingSite = null
      })
      .addCase(getById.rejected, (state) => {
        state.getByIdLoading = false
      })
      .addCase(getById.fulfilled, (state, action) => {
        state.getByIdLoading = false
        state.selectedManufacturingSite = action.payload
      })

      .addCase(getForMfsStanceById.pending, (state) => {
        state.getByIdLoading = true
        state.selectedManufacturingSite = null
      })
      .addCase(getForMfsStanceById.rejected, (state) => {
        state.getByIdLoading = false
      })
      .addCase(getForMfsStanceById.fulfilled, (state, action) => {
        state.getByIdLoading = false
        state.selectedManufacturingSite = action.payload
      })
      .addCase(addManufacturingSite.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(addManufacturingSite.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(addManufacturingSite.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(updateManufacturingSite.pending, (state) => {
        state.saveLoading = true
      })
      .addCase(updateManufacturingSite.rejected, (state) => {
        state.saveLoading = false
      })
      .addCase(updateManufacturingSite.fulfilled, (state) => {
        state.saveLoading = false
      })

      .addCase(loadManufacturingSiteLookups.fulfilled, (state, action) => {
        state.specialties = action.payload.specialties
        state.countries = action.payload.countries
        state.natureOfActivities = action.payload.natureOfActivities
        state.pdlActivities = action.payload.pdlActivities
      })
      .addCase(initManufacturingSite.fulfilled, (state) => {
        state.selectedManufacturingSite = null
      })

    builder.addCase(getComments.pending, (state) => {
      state.comments = []
      state.commentsLoading = true
    })

    builder.addCase(getComments.rejected, (state) => {
      state.comments = []
      state.commentsLoading = false
    })
    builder.addCase(getComments.fulfilled, (state, action) => {
      state.comments = action.payload.comments ?? []
      state.commentsLoading = false
    })
    builder.addCase(deleteComment.pending, (state) => {
      state.deleteCommentLoading = true
    })

    builder.addCase(deleteComment.rejected, (state) => {
      state.deleteCommentLoading = false
    })

    builder.addCase(deleteComment.fulfilled, (state, action) => {
      state.deleteCommentLoading = false
      state.comments = [...state.comments.filter(e => e.id !== action?.meta?.arg?.id)]
    })
    builder.addCase(addComment.pending, (state) => {
      state.addCommentLoading = true
    })

    builder.addCase(addComment.rejected, (state) => {
      state.addCommentLoading = false
    })

    builder.addCase(addComment.fulfilled, (state, action) => {
      state.addCommentLoading = false
      // prepend new comment to the list
      state.comments = [action.payload, ...state.comments]
    })
  }
})

export const { deleteItem } = appManufacturingSiteSlice.actions

export default appManufacturingSiteSlice.reducer
